/**
 * Api执行失败的错误码信息
 * @param {String} errno 错误码
 */
class ApiErrno {
  static Errno(category1: string, category2: string, errorType: string) {
    return parseInt(`${category1}${category2}${errorType}`);
  }
};
  
/**
 * 错误码一级类目，API大类
 */
const errnoCategory1 = {
  COMMON: '00',
  BASIC_CAPABILITY: '01',
  ROUTE_CAPABILITY: '02',
  UI_CAPABILITY: '03',
};
    
/**
 * 错误码二级类目，该API处于大类中的位置
 */
const errnoCategory2 = {
  COMMON: '00',
  UI_INTERACTION: '01',
  UI_NAVIGATION_BAR: '02',
  UI_BACKGROUND: '03',
  UI_TAB_BAR: '04',
  UI_FONT: '05',
  UI_PULL_DOWN_REFRESH: '06',
  UI_ROLLING: '07',
  UI_CUSTOM_COMPONENTS: '08',
  UI_MENU:'09'
};
    
/**
 * 错误码类型，错误类型
 */
const errorType = {
  INVALID_TYPE: '001',
  INVALID_VALUE: '002',
  MISSING_PARAM: '003',
};
    
export { 
  ApiErrno,
  errnoCategory1,
  errnoCategory2,
  errorType
};